export enum TooltipAvailable {
	PRODUCT_DESC = 250,
	SHOW_DESC_TOOLTIP = 2.5,
}
